const GLOBAL_PERMISSIONS_LOGIN_REFRESH_REQUIRED = 'global-permissions-login-refresh-required';

export function markGlobalPermissionsRefreshRequiredAfterLogin(): void {
    window.localStorage.setItem(GLOBAL_PERMISSIONS_LOGIN_REFRESH_REQUIRED, 'true');
}

export function consumeGlobalPermissionsRefreshRequiredAfterLogin(): boolean {
    const isRequired = window.localStorage.getItem(GLOBAL_PERMISSIONS_LOGIN_REFRESH_REQUIRED) === 'true';
    window.localStorage.removeItem(GLOBAL_PERMISSIONS_LOGIN_REFRESH_REQUIRED);
    return isRequired;
}

export function clearGlobalPermissionsRefreshRequiredAfterLogin(): void {
    window.localStorage.removeItem(GLOBAL_PERMISSIONS_LOGIN_REFRESH_REQUIRED);
}